export enum CustomizationType {
    TEXT = 'TEXT',
    CHECKBOX = 'CHECKBOX',
}

export type ProductCustomization = {
    id: string;
    value: string[] | string | null | undefined;
    type: CustomizationType;
};

export interface AddProductPayload {
    product_id: string;
    variation_id: string;
    quantity?: number;
    metadata?: Record<string, unknown>;
    product_customizations?: ProductCustomization[];
}

export interface BuyProductPayload {
    product_id: string;
    variation_id: string;
    /** Optional, provide only when buying subscription */
    plan_id?: string;
    /** Optional, defaults to 1 (subscription only support 1) */
    quantity?: number;
    metadata?: Record<string, unknown>;
    product_customizations?: ProductCustomization[];
}

export interface BuyBookingPayload {
    /** Display name of the event */
    event_name: string;
    /** Event type that can be booked */
    event_type_id: number;
    /** Start of the booking slot to reserve example */
    slot_start: string;
    /** (Optional) Duration in minutes of the slot to reserve - NOTE: Only for event types with variable length */
    slot_duration?: number;
    /** Selected by user from Booker atom, example: 'America/Montreal' */
    time_zone: string;
    /** Name of the customer, used to prefill checkout */
    customer_name?: string;
    /** Email of the customer, used to prefill checkout */
    customer_email?: string;
    /** JSON string of metadata */
    metadata: object;
    /** Maps to Cal.com bookingFields, example: { customField: "customValue" } */
    fields_responses?: object;
}

export interface EcomSDK {
    ready: Promise<void>;
    addProduct: (params: AddProductPayload) => Promise<void>;
    buyProduct: (params: BuyProductPayload) => Promise<void>;
    buyBooking: (params: BuyBookingPayload) => Promise<void>;
}
